"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class VerifyNewCardResponse {
}
exports.default = VerifyNewCardResponse;
//# sourceMappingURL=VerifyNewCardResponse.js.map